import { useState, useEffect } from "react";
import { Sun, Moon } from "lucide-react";

// Hook reactivo: informa a cualquier componente si el modo oscuro está activo,
// observando la clase `dark` en <html>. Útil para estilos en línea (no CSS).
export function useDarkMode() {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));
  useEffect(() => {
    const obs = new MutationObserver(() => setDark(document.documentElement.classList.contains("dark")));
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    return () => obs.disconnect();
  }, []);
  return dark;
}

// Interruptor de modo claro/oscuro.
// La clase `dark` vive SOLO en <html> (document.documentElement); no envuelve la app.
// La preferencia se persiste en localStorage.
export function ThemeToggle() {
  const [dark, setDark] = useState(() => localStorage.getItem("theme") === "dark");

  useEffect(() => {
    const root = document.documentElement;
    if (dark) {
      root.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      root.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [dark]);

  return (
    <button
      onClick={() => setDark((d) => !d)}
      data-testid="theme-toggle"
      title={dark ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
      className="flex items-center gap-2 text-base font-bold text-white/90 hover:text-white transition-colors justify-center group-hover:justify-start w-full mb-3"
    >
      {dark ? <Sun size={18} className="shrink-0" /> : <Moon size={18} className="shrink-0" />}
      <span className="hidden group-hover:inline">{dark ? "Modo claro" : "Modo oscuro"}</span>
    </button>
  );
}
